//lib
import { Icon } from "@iconify/react";
import { useNavigate } from "react-router-dom";

//redux
import { useSelector } from "react-redux";

//component
import Image from "../element/image";
import Row from "../element/row";
import Col from "../element/col";

//asset
import { FooterLogo, Techpole } from "../../assets/images";
import Container from "../element/container";
import useWindowDimension from "../hook/use.window.dimension";

export default function Footer() {
  const navigate = useNavigate();
  const { width } = useWindowDimension();
  const { contactList, footerList } = useSelector((state) => state.common);

  const handleNavigate = (page) => {
    navigate(page);
  };

  return (
    <footer className="footer">
      <Row tag="section" className="_row contact-list">
        {contactList.map((contact, contactIndex) => (
          <Col className="_col contact-item" key={contactIndex}>
            <h6 className="_label contact-title">{contact.label}</h6>
          </Col>
        ))}
      </Row>
      <Row tag="section" className="_row footer-list">
        <Col className="v-flex gap-4">
          <Image className="_img logo" src={FooterLogo} />
          <p className="_label footer-title">{footerList.description}</p>
          <Row className="h-flex mt-4 gap-5">
            <article className={width < 500 && "w-100"}>
              <h6 className="_label opening-hours">Opening Hours</h6>
            </article>
            {footerList.opening_hour.map((opening, openingIndex) => (
              <Col className="_col opening-item" key={openingIndex}>
                <h6 className="_label opening-title">{opening.label}</h6>
                <h6 className="_label opening-subtitle">
                  {opening.description}
                </h6>
              </Col>
            ))}
          </Row>
        </Col>
        <Col className="_col shortcut-item">
          {footerList.shortcut.map((shortcut, shortcutIndex) => (
            <h4
              className="_label shortcut-title pointer"
              onClick={() => handleNavigate(shortcut.navigate)}
            >
              {shortcut.label}
            </h4>
          ))}
        </Col>
        <Col>
          <h6 className="_label explore">Explore</h6>
          <Row className="v-flex gap-3 mt-3">
            {footerList.explore.map((explore, exploreIndex) => (
              <Col key={exploreIndex}>
                <h6
                  className="_label explore-title pointer"
                  onClick={() => handleNavigate(explore.navigate)}
                >
                  {explore.label}
                </h6>
              </Col>
            ))}
          </Row>
        </Col>
      </Row>
      <Row tag="section" className="_row extra-list">
        <p className="_label extra">
          DC Fashion {new Date().getFullYear()}. All rights reserved. (v
          {process.env.REACT_APP_VERSION})
        </p>
        <Col className={`h-flex gap-${width > 600 ? 3 : 3} pointer`}>
          {footerList.extra.map((extra, extraIndex) => (
            <>
              <p
                className="_label extra-title"
                onClick={() => window.open(extra.href, "_blank")}
              >
                {extra.label}
              </p>
              {extraIndex !== 2 && <p className="_label extra-title">•</p>}
            </>
          ))}
        </Col>
      </Row>
    </footer>
  );
}
